import { Component, h, Host, JSX, Prop } from "@stencil/core";
import getSuggestionHighlight from "./get-suggestion-highlight";

@Component({
    tag: "ux-autosuggest-item",
    styleUrl: "autosuggest-item.scss",
    shadow: false
})
export class AutosuggestItem {
    /**
     * Search query that will be highlighted in the text
     */
    @Prop() readonly input?: string = "";

    /**
     * Suggestion text that matches the input
     */
    @Prop() readonly text?: string = "";

    /**
     * Subline below the text
     */
    @Prop() readonly subline?: string = "";

    /**
     * Optional image URL
     */
    @Prop() readonly image?: string = "";

    /**
     * If set, the suggestion item will be slim, without a subline
     */
    @Prop() readonly slim: boolean = false;

    render(): JSX.Element {
        const baseClass = "ux-autosuggest-item";
        const { text, subline, image, input } = this;
        const [highlight, remaining] = getSuggestionHighlight(input || "", text || "");
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--slim`]: this.slim
                }}
            >
                {image !== "" && <div class={`${baseClass}__image`} style={{ backgroundImage: `url(${image})` }} />}
                <div
                    class={{
                        [`${baseClass}__text-container`]: true,
                        [`${baseClass}__text-container--slim`]: this.slim
                    }}
                >
                    <div class={`${baseClass}__text`}>
                        <span class={`${baseClass}__highlight`}>{highlight}</span>
                        {remaining}
                    </div>
                    {!this.slim && <div class={`${baseClass}__subline ux-text-tiny ux-text-tiny--bold`}>{subline}</div>}
                </div>
            </Host>
        );
    }
}
